import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Group, Text } from "@mantine/core";
import styled from "styled-components";
import toast from "react-hot-toast";

import { CodeInput } from "@components/Auth";

const ContactMethodVerification = ({
  isPhone = false,
  isEmail = false,
  onSuccess,
  value,
}) => {
  const [loading, setLoading] = useState(false);
  const [codeValue, setCodeValue] = useState("");
  const [remoteCode, setRemoteCode] = useState(null);
  const [codeValidated, setCodeValidated] = useState(false);

  function resetState() {
    setCodeValue("");
    setRemoteCode(null);
    setCodeValidated(false);
  }

  useEffect(() => {
    if (codeValue.length === 6) {
      verifyCode();
    }
  }, [codeValue]);

  function sendCodeToMethod() {
    setLoading(true);

    const req = {};

    if (isEmail) req.email = value;
    if (isPhone) req.mobile_phone = value;

    axios
      .post(`/microsite/send-verification/`, req)
      .then(({ data }) => {
        setLoading(false);
        setRemoteCode(data.response[0]);
      })
      .catch((err) => {
        toast.error(err);
        setLoading(false);
      });
  }

  function verifyCode() {
    const req = {
      code: codeValue,
      remote_code_id: remoteCode.remote_code_id,
    };

    axios
      .post(`/microsite/verify-code/`, req)
      .then(() => {
        setCodeValidated(true);
      })
      .catch((err) => {
        toast.error(err);
        setCodeValue("");
      });
  }

  if (codeValidated) {
    return (
      <div>
        <Text mb="sm" fw={600} align="center">
          Code validated
        </Text>
      </div>
    );
  }

  return (
    <React.Fragment>
      {remoteCode ? (
        <React.Fragment>
          {remoteCode.opted_out ? (
            <>
              <Text mb="md">
                This phone number has opted out of receiving text messages. Text
                START to <b>{remoteCode.opt_in_number}</b> to opt-in.
              </Text>
              <Button onClick={() => setRemoteCode(null)}>Try again</Button>
            </>
          ) : (
            <>
              <Text mb="sm" align="center" fw={600} size="sm">
                {isEmail &&
                  `An email was sent to ${value} containing a six digit code.`}
                {isPhone &&
                  `A text was sent to ${value} containing a six digit code.`}{" "}
                Enter the six digit code below.
              </Text>
              <StyledInputs>
                <CodeInput
                  value={codeValue}
                  onChange={(e) => setCodeValue(e)}
                />
              </StyledInputs>
              <Group justify="center">
                <Button
                  variant="subtle"
                  color="gray"
                  size="xs"
                  mt="lg"
                  onClick={() => setRemoteCode(null)}
                >
                  Back
                </Button>
              </Group>
            </>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Button
            loading={loading}
            onClick={sendCodeToMethod}
            disabled={!value}
          >
            Send verification code
          </Button>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const StyledInputs = styled.div`
  input {
    border: 1px solid #000;
    background: #eee;
  }
`;

export default ContactMethodVerification;
